import type { Session } from "next-auth"

/**
 * Single source of truth for "is this session an admin".
 *
 * `session.user.isAdmin` is derived in the NextAuth jwt callback
 * (src/pages/api/auth/[...nextauth].ts) from the `userWhitelistAccess` Firestore
 * collection, which is managed from the admin User Access page. There is no
 * env-var allowlist - check this, never an email list.
 */
export function isSessionAdmin(session: Session | null | undefined): boolean {
  return session?.user?.isAdmin === true
}
